import { locale as onboardingDialog } from '../components/onboarding-dialog/i18n/en';

export const locale = {
    lang: 'en',
    data: {
        ...onboardingDialog.data
    }
};
